import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

//imported by me
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
//modal widget
import { ModalModule } from 'ngx-bootstrap/modal';
//Linkedin, github icons
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome'
//

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { TimelineComponent } from './timeline/timeline.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { ProjectComponent } from './projects/projects.component';
import { SkillsComponent} from './skills/skills.component';
import { TechnicalComponent} from './technical/technical.component';
import { routing } from './app.routing';

//pipes
import {SearchFilterPipe} from './pipes/searchFilter.pipe'

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TimelineComponent,
    NotFoundComponent,
    ProjectComponent, 
    SkillsComponent,
    TechnicalComponent,
    SearchFilterPipe
  ],
  imports: [
    BrowserModule,
    routing,
    HttpModule,
    Angular2FontawesomeModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }
